import React, {useEffect} from 'react';
import {Button, Col, Form, Row} from "antd";
import {useLocation} from "react-router-dom";
import {useEditQuery, useGetByIdQuery, usePostQuery} from "../../service/query/Queries";
import {EditGetById, SetInitialValue, SuccessCreateAndEdit} from "../../hooks";
import {AppLoader, FormInput} from "../../components";



const initialValueForm = {
    name: "",
    key: "",


}


const FloorPostEdit = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const editId = queryParams.get('editId');
    const [form] = Form.useForm();
    console.log()

    const {
        mutate: postOfficeMutate,
        isLoading: postOfficeLoading,
        isSuccess: postOfficeSuccess

    } = usePostQuery()
    const {
        isLoading: editOfficeLoading,
        data: editOfficeData,
        refetch: editOfficeRefetch,
        isSuccess: editOfficeSuccess
    } = useGetByIdQuery(false, "edit-office", editId, '/office')
    const {
        mutate: putOffice,
        isLoading: putOfficeLoading,
        isSuccess: putOfficeSuccess
    } = useEditQuery()


    SuccessCreateAndEdit(postOfficeSuccess, putOfficeSuccess, '/office')

    EditGetById(editOfficeRefetch, editId)

    SetInitialValue(form, initialValueForm)


    useEffect(() => {
        if (editOfficeSuccess) {

            const edit = {

                key: editOfficeData?.key,
                name: editOfficeData?.name,
            }
            form.setFieldsValue(edit)
        }
    }, [editOfficeData])


    const onFinish = (value) => {
        const data = {
            name: value.name,
            key: value.key,
        }
        if (editOfficeData) {
            putOffice({url: `/office`, data: data, id: editId})
        } else {
            postOfficeMutate({url: `/office`, data: data});
        }
    }


    return (
        <div>
            {(postOfficeLoading || editOfficeLoading || putOfficeLoading) ?
                <AppLoader/> :
                <Form
                    form={form}
                    name="basic"
                    labelCol={{
                        span: 24
                    }}
                    wrapperCol={{
                        span: 24
                    }}
                    style={{
                        maxWidth: "100%"
                    }}
                    initialValues={initialValueForm}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={20}>

                        <Col span={24}>
                            <FormInput
                                required={true}
                                required_text={'Требуется название офис'}
                                label={'Название офис:'}
                                name={'name'}
                            />
                        </Col>
                        <Col span={24}>
                            <FormInput
                                required={true}
                                required_text={'Требуется  код'}
                                label={' Код:'}
                                name={'key'}
                            />
                        </Col>


                    </Row>
                    <Button type="primary" htmlType="submit" style={{width: "100%", marginTop: "20px"}}>
                        {editOfficeSuccess ? 'Редактировать' : 'Создать'}
                    </Button>
                </Form>}
        </div>);
};

export default FloorPostEdit;